/**
 * 
 */
export default [
    {
        field   : 'number',
        value   : '',
        label   : 'Folio',
    },
]
